import React from 'react';
import PropTypes from 'prop-types';

import { IconRefresh } from 'svgIcons/MotionPortalIcons';
import { GeneralButton } from 'sharedComponents/GeneralButton';
import { translate } from 'helpers/translateHelper';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import colors from 'theme/_colors.scss';

const LastUpdated = ({ isActiveList, assetsLastUpdatedTimestamp, lastUpdatedTimestamp, requestHierarchyData }) => {
    const ts = isActiveList ? assetsLastUpdatedTimestamp : lastUpdatedTimestamp;
    if (!ts) { return null; }

    return (
        <div className={'last-updated-timestamp'}>
            <span>{translate('ABB.Powertrain.Frontend.reportLastUpdated')}: {formatDateTime(ts)}</span>
            <GeneralButton
                type='normal'
                icon={<IconRefresh width={16} height={16} color={colors.primaryInfo} />}
                text={translate('ABB.Powertrain.Frontend.reportsRefreshReportsLabel')}
                onClick={() => {
                    if (requestHierarchyData) { requestHierarchyData(); }
                }}
            />
        </div>
    );
};

LastUpdated.propTypes = {
    isActiveList: PropTypes.bool,
    assetsLastUpdatedTimestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
    lastUpdatedTimestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)]),
    requestHierarchyData: PropTypes.func,
};

export default LastUpdated;
